<template>
    <div class="about-landing" v-once>
        <section class="section">
            <div class="container">
                <div>
                    <div style="padding-bottom:30px;">
                            <p class><b style="font-size:30px;">Plans & Pricing</b><br>
                            Sign up for a free trial</p>
                        </div>

                        <div>
                            <table id="pricePlansTable" class="price-plans-table table table-hover">
                                <thead class="price-plans-table-header white">
                                    <tr>
                                        <th class="col-md-6"></th>
                                        <th class="col-md-3">
                                            <h4>LogBox Core</h4></th>
                                        <th class="col-md-3">
                                            <h4>LogBox Premium</h4></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="price-plans-table-rows" v-for="(feature,index) in plans" :key="index">
                                        <td>{{feature.name}}</td>
                                        <td><i v-if="feature.isCoreActive" class="price-plan-icons fas fa-check fa-lg"></i></td>
                                        <td><i v-if="feature.isPremiumActive" class="price-plan-icons fas fa-check fa-lg"></i></td>
                                    </tr>
                                </tbody>
                                <tfoot class="price-plans-table-footer white">
                                    <tr>
                                        <tr>
                                            <td></td>
                                            <td>
                                                <h4>R250/ month</h4></td>
                                            <td>
                                                <h4>R970/ month</h4></td>
                                        </tr>
                                        <tr class="align-center">
                                            <td></td>
                                            <td>
                                                <p>R2500 once-off practice
                                                    <br/> configuration and training fee</p>
                                            </td>
                                            <td>
                                                <p>R2500 once-off practice
                                                    <br/> configuration and training fee</p>
                                            </td>
                                        </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div style="padding-top:30px;" class="row">
                            <div class="col-sm-6">
                                <div class="card">
                                    <div class="card-pp-discount card-body">
                                       Academic Units (State sector) qualify for 50% Discount
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="card">
                                    <div class="card-pp-discount card-body">
                                        Allied health (Single practice) qualify for 20% Discount
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="text-center">
                            <router-link to="/signup" class="btn practice-pp-signup-btn">SIGN UP NOW</router-link>
                            </div>
                        </div>
                    </div>
                </div>
        </section>
    </div>
</template>

<script>
export default {
  name: 'priceplans',
  components: {},
  data: () => ({
    plans: [
      {
        name: 'Patient onBoarding',
        isCoreActive: true,
        isPremiumActive: true,
      },
      {
        name: 'Demographics',
        isCoreActive: true,
        isPremiumActive: true,
      },
      {
        name: 'Messaging Module',
        isCoreActive: true,
        isPremiumActive: true,
      },
      {
        name: 'Document Storage',
        isCoreActive: true,
        isPremiumActive: true,
      },
      {
        name: 'Integration with medical billing systems',
        isCoreActive: true,
        isPremiumActive: true,
      },
      {
        name: 'Clinical case collaboration for multidisciplinary teams',
        isCoreActive: false,
        isPremiumActive: true,
      },
      {
        name: 'Digital Clinical Notes',
        isCoreActive: false,
        isPremiumActive: true,
      },
      {
        name: 'Clinical Activity feed',
        isCoreActive: false,
        isPremiumActive: true,
      },
      {
        name: 'Customisable clinical templates',
        isCoreActive: false,
        isPremiumActive: true,
      },
      {
        name: 'Clinical Database creation',
        isCoreActive: false,
        isPremiumActive: true,
      },
      {
        name: 'Preadmissions',
        isCoreActive: false,
        isPremiumActive: true,
      },
      {
        name: 'Theatre lists',
        isCoreActive: false,
        isPremiumActive: true,
      },
      {
        name: 'Waiting List',
        isCoreActive: false,
        isPremiumActive: true,
      },
    ],
  }),
};
</script>
<style scoped>
.price-plans-table {
    box-shadow: 0 6px 6px -1px rgb(201, 202, 202);
}

.price-plans-table-header,
.price-plans-table-footer {
    border-radius: 5%;
    background-image: linear-gradient(49deg, rgb(20, 211, 171) 30%, rgb(0, 178, 179) 80%);
}

.practice-pp-signup-btn {
    background-color: #14D3AB;
    color: white;
  }

.price-plans-table-rows {
    background-color: rgba(233, 233, 233, 0.6);
}

.price-plan-icons {
    color: rgb(201, 202, 202);
}

.card-pp-discount {
    padding: 4%;
    text-align: center;
    background-color: rgba(233, 233, 233, 0.6);
}
</style>



// WEBPACK FOOTER //
// PricePlans.vue?7873e00e